



import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import { FirebaseService } from '../../_services/';


@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  resetPasswordForm : FormGroup;
  submitted:Boolean = false;
  successMsg:String;
  errMsg:String;
  constructor(
    private _firebase:FirebaseService, 
    private formBuilder : FormBuilder,
    private _router : Router
  ) { }

  ngOnInit() {
    if(localStorage.getItem('uid')){
      this._router.navigate(['/leads-list'])
    }
    this.resetPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email, Validators.maxLength(200)]]
    })
  }

  get fval() {
    return this.resetPasswordForm.controls;
    }

  onFormSubmit(form):void {
    this.submitted = true;
    // this.successMsg='';
    // this.errMsg='';
    if (this.resetPasswordForm.invalid) {
      return;
    }
    // this._common.showLoader(true);
    this._firebase.ResetPassword(form.value.email).then(res => {
      // this._common.showLoader(false);
      // this._alert.success('Check your email for further instructions');
      this.successMsg = 'Check your email for further instructions';

      this.resetPasswordForm.reset();
      this.submitted = false;
    }).catch((err) => {
      // this._common.showLoader(false);
      // this._alert.error(err.message);
      this.errMsg = err.message;
    })

  }

}
